import React, { useState, useEffect } from "react";
import CourseHeader from "../../../Components/CourseHeader";
import { icons } from "../../../Assests/icons-imports/icons";
import CommonDataTable from "../../../Components/CommonDataTable";
import { Helmet } from "react-helmet-async";
import useGetApi from "../../../services/useGetApi";
import IconButton from "../../../Components/IconButton";
import { DeleteOutlined, EditOutlined, EyeOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import useDelete from "../../../services/useDelete";

const Instructors = () => {
  const [isLoading, error, userData, getData] = useGetApi(
    `users?role=instructor`,
    [],
    true
  );
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    getData(`users?role=instructor`);
  }, []);

  const [isDeleteLoading, deleteError, deleteData] = useDelete();

  const handleEdit = (userData) => {
    setLoading(true);
    console.log("editUserData", userData);
    navigate(`/users/admin-instructors/edit/${userData.id}`, userData);
  };

  const handleDelete = async (userId) => {
    setLoading(true);
    console.log("userId", userId);
    try {
      const res = await deleteData(`users/${userId}`, true);
      console.log("res  is here ", res);
      // if (res) {
      getData(`users?role=instructor`);
      // }
    } catch (err) {
      console.error("Submission error:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleView = () => {
    console.log("handleView");
  };

  const columns = [
    {
      title: "First Name",
      dataIndex: "firstName",
      key: "firstName",
    },
    {
      title: "Last Name",
      dataIndex: "lastName",
      key: "lastName",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (_, record) => (
        <div style={{ display: "flex", gap: "10px" }}>
          <IconButton
            icon={EditOutlined}
            onClick={() => handleEdit(record)}
            style={{ color: "blue" }}
          />
          <IconButton
            icon={DeleteOutlined}
            onClick={() => handleDelete(record.id)}
            style={{ color: "red" }}
          />
          {/* <IconButton
            icon={EyeOutlined}
            onClick={() => handleView(record)}
            style={{ color: "green" }}
          /> */}
        </div>
      ),
    },
  ];

  return (
    <div>
      <Helmet>
        <title>Manage Instructors | LMS-admin</title>
      </Helmet>
      <div className="d-flex gap-3 px-3">
        <div className="mt-5 pt-5 d-flex flex-column gap-4 w-100">
          <CourseHeader
            header={"Instructor"}
            btnName={"Add instructor"}
            icon={icons.apple_icon}
            redirectTo={"/users/admin-instructors/add"}
          />
          <div className="p-3 bg-white">
            <CommonDataTable
              columns={columns}
              dataSource={userData}
              loading={loading}
              tableTitle={"Instructor"}
              search={true}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Instructors;
